/**
 * Parse ddmmyyyy date into JSONDate (yyyy-mm-dd)
 * @param d
 */
import {JsonDate} from "./types";
import {format} from "date-fns";

export function parseDate(d: string | undefined) {
    if (! d) {
        return d;
    }
    const bits = d.trim().split(/\//);
    return bits[2] + "-" + bits[1] + "-" + bits[0];
}

/**
 * Format JSONDate (yyyy-mm-dd) to dd/mm/yyyy
 */
export function formatDate(d: JsonDate | undefined) {
    if (! d) {
        return d;
    }
    const bits = d.trim().split(/-/);
    return bits[2] + "/" + bits[1] + "/" + bits[0];
}

export function now() {
    return new Date();
}

export function todayJSONDate() : JsonDate {
    return format(now(), "yyyy-MM-dd");
}

export function toJSONDate(date: Date) : JsonDate {
    return format(date, "yyyy-MM-dd");
}

export function formatTimestamp(ts: number) {
    const date = new Date(ts);
    return format(date, "yyyy-MM-dd HH:mm:SS");
}
